export enum Icons {
  add = 'add',
  arrowBack = 'arrow_back',
  aspectRatio = 'aspect_ratio',
  assignment = 'assignment',
  assignmentReturn = 'assignment_return',
  cancel = 'cancel',
  checkCircle = 'check_circle',
  close = 'close',
  create = 'create',
  copy = 'copy',
  done = 'done',
  errorOutline = 'error_outline',
  expandLess = 'expand_less',
  expandMore = 'expand_more',
  engineering = 'engineering',
  info = 'info',
  link = 'link',
  filter = 'filter',
  filterAlt = 'filter_alt',
  health_and_safety = 'health_and_safety',
  linkOff = 'link_off',
  lock = 'lock',
  lockOpen = 'lock_open',
  moreHoriz = 'more_horiz',
  person = 'person',
  personAdd = 'person_add',
  personAddDisabled = 'person_add_disabled',
  personAdded = 'person_added',
  pictureAsPdf = 'picture_as_pdf',
  refresh = 'refresh',
  reportProblem = 'report_problem',
  search = 'search',
  support_agent = 'support_agent',
  openInNew = 'open_in_new',
  mail = 'mail',
  send = 'send',
  pdf = 'pdf',
  pause = 'pause',
  expandCircleDown = 'expand_circle_down',
  expandCircleUp = 'expand_circle_up',
  timer = 'timer',
  menu = 'menu',
  menue = 'menue',
  pending_actions = 'pending_actions',
  faxeit = 'faxeit',
  workspace_premium = 'workspace_premium',
  rule = 'rule',
  alarm_on = 'alarm_on',
  overview = 'overview',
  calendar_add = 'calendar_add',
  public = 'public',
  widgets = 'widgets',
  verified = 'verified',

}
